import type { SuggestionSource } from '@app/src/pages/Questionnaire/Provider/Report/SuggestedAnswers/suggestionSources'
import type { Inquiry, ResponseItem } from '@app/src/types/resourceExplorer'
import { createContext, useContext } from 'react'

export type ProviderReportContextProps = {
  previouslyRespondedQuestions?: ResponseItem[]
  suggestedAnswersPerQuestion?: ResponseItem[]
  providerInquiries: Inquiry[]
  isLoadingPreviousAnswer?: boolean
  isFetchingProviderInquiries: boolean
  isPreparingDraft: boolean
  recordAutofill: (source: SuggestionSource) => void
}

const ProviderReportContext = createContext<ProviderReportContextProps>({
  previouslyRespondedQuestions: [],
  suggestedAnswersPerQuestion: [],
  isLoadingPreviousAnswer: true,
  providerInquiries: [],
  isFetchingProviderInquiries: true,
  isPreparingDraft: false,
  recordAutofill: () => undefined,
})

export const useProviderReport = (): ProviderReportContextProps => {
  return useContext(ProviderReportContext)
}

export default ProviderReportContext
